import { z } from 'zod';

export const ordemTrabalhoSchema = z.object({
  ordem_trabalho: z
    .string()
    .min(1, 'A ordem de trabalho é obrigatória')
    .max(20, 'A ordem de trabalho deve ter no máximo 20 caracteres')
    .regex(/^[a-zA-Z0-9]+$/, 'A ordem de trabalho deve conter apenas letras e números')
});

export type OrdemTrabalhoFormData = z.infer<typeof ordemTrabalhoSchema>;
